import React, { useState } from "react";
import { toggle } from "../../../util/common";
import { WalletItemDriverLicence } from "../../../store/common";
import { DialogComponent } from "../../common/DialogComponent";
import ConfirmDeleteWalletDialog from "../../Dialogs/lostWallet/ConfirmDeleteWalletDialog";
import DriverLicenseDialog from "../../Dialogs/lostWallet/DriverLicenseDialog";
import { countryList } from "../../../util/CommonLists";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { useTranslation } from "react-i18next";
import { getFormattedDate } from "../../../util/dateFormatting";
import moment from "moment";

const DriversLicense: React.FunctionComponent<{ requestDataCallback(): void; walletItemDriverLicences: WalletItemDriverLicence[] }> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [deleteWalletDialogIsVisible, setDeleteWalletDialogIsVisible] = useState(false);
    const [driversLicenseDialogIsVisible, setDriversLicenseDialogIsVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});
    const [driverLicenseCardNumber, setDriverLicenseCardNumber]:any = useState([]);
    const [driverLicenseDateOfBirth, setDriverLicenseDateOfBirth]:any = useState([]);
    const showDeleteWalletDialog = (selectedItem: WalletItemDriverLicence): any => {
        setSelectedItem(selectedItem);
        setDeleteWalletDialogIsVisible(true);
    };

    const closeDeleteWalletDialog = (): any => {
        setDeleteWalletDialogIsVisible(false);
    };

    const showDriversLicenseDialog = (selectedItem: WalletItemDriverLicence): any => {
        setSelectedItem(selectedItem);
        setDriversLicenseDialogIsVisible(true);
    };

    const closeDriversLicenseDialog = (): any => {
        setDriversLicenseDialogIsVisible(false);
    };

     const toggleDOBVisibility =(driverLicence:any) =>{
        if (driverLicenseDateOfBirth.length > 0) {
            const index = driverLicenseDateOfBirth.findIndex((element: any) => element.dateOfBirth === driverLicence.dateOfBirth);
         if (index >= 0) {
            driverLicenseDateOfBirth.splice(index, 1);
            setDriverLicenseDateOfBirth([...driverLicenseDateOfBirth]);
        } 
         else {
            setDriverLicenseDateOfBirth([...driverLicenseDateOfBirth, driverLicence]);
         }
          } else {
            setDriverLicenseDateOfBirth([...driverLicenseDateOfBirth , driverLicence]);
         }
     }

     const toggleDriverLicenseNumberVisibility =(driverLicence:any)=>{
       if (driverLicenseCardNumber.length > 0) {
            const index = driverLicenseCardNumber.findIndex((element: any) => element.driverLicenseNumber ===  driverLicence.driverLicenseNumber);
         if (index >= 0) {
            driverLicenseCardNumber.splice(index, 1);
            setDriverLicenseCardNumber([...driverLicenseCardNumber]);
        } 
         else {
            setDriverLicenseCardNumber([...driverLicenseCardNumber, driverLicence]);
         }
          } else {
            setDriverLicenseCardNumber([...driverLicenseCardNumber , driverLicence]);
         }
     }
    return (
        <React.Fragment>
            {props.walletItemDriverLicences &&
                props.walletItemDriverLicences.map((driverLicence: WalletItemDriverLicence, index) => (
                    <div className="data-row" key={"driver-licence-" + index}>
                        <div className="link-item">
                            <button
                                type="button"
                                aria-expanded="false"
                                className="link-button"
                                id={"drivers-license-" + index}
                                onClick={() => toggle(`drivers-license-${index}-details`, `drivers-license-${index}`)}
                            >
                                <span className="row link-item">
                                    <span className="col-xs col-no-gutter link-text">
                                        <span className="link-title">
                                            <span className="sr-only btn-toggle-status">Show</span> {driverLicence.firstName + " " + driverLicence.lastName}
                                        </span>
                                        <span className="link-helper">
                                            <span className="sr-only">Item Type: </span>
                                            {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.title2")}
                                        </span>
                                    </span>
                                </span>
                            </button>

                            <div className="wallet-details" id={"drivers-license-" + index + "-details"} style={{ display: "none" }}>
                                <div
                                    role="grid"
                                    className="data-grid row-height-xs"
                                    id={"drivers-license-" + index + "-title"}
                                    aria-labelledby={"drivers-license-" + index + "-title"}
                                >
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"drivers-license-" + index + "-first-name"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.fname")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"drivers-license-" + index + "-first-name"}>
                                                {driverLicence.firstName}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"drivers-license-" + index + "-middle-initial"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.mName")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"drivers-license-" + index + "-middle-initial"}>
                                                {driverLicence.middleName}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"drivers-license-" + index + "-last-name"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.lName")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"drivers-license-" + index + "-last-name"}>
                                                {driverLicence.lastName}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"drivers-license-" + index + "-suffix"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.suffix")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"drivers-license-" + index + "-suffix"}>
                                                {driverLicence.suffix}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"drivers-license-" + index + "-sex"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.sex")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"drivers-license-" + index + "-sex"}>
                                                {driverLicence.sex}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"drivers-license-" + index + "-height"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.height")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"drivers-license-" + index + "-height"}>
                                                {driverLicence.height}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"drivers-license-" + index + "-date-of-birth"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.dob")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"drivers-license-" + index + "-date-of-birth"}>
                                             {driverLicence.dateOfBirth &&  driverLicenseDateOfBirth.findIndex((element: any) => element.dateOfBirth === driverLicence.dateOfBirth) < 0 
                                               ? (i18nService.get("Country") === "US" 
                                                  ? moment(driverLicence.dateOfBirth).format("MMM D ****") 
                                                  : i18nService.get("Country") === "CA" || i18nService.get("Country") === "TW" 
                                                  ? moment(driverLicence.dateOfBirth).format("**** MMM D")
                                                  : moment(driverLicence.dateOfBirth).format("D MMM ****"))
                                                : driverLicence.dateOfBirth && getFormattedDate(i18nService.get("Country"), driverLicence.dateOfBirth)} 
                                                  <button
                                                type="button"
                                                className="btn-default btn-icon-only btn-no-padding"
                                                onClick={() => {
                                                   toggleDOBVisibility(driverLicence);
                                                }}
                                                title={"Show DOB Text"}
                                                style={{marginLeft: '1.25rem'}}
                                            >
                                                <span className="btn-icon">
                                                    <em
                                                        className={ driverLicence.dateOfBirth? `las ${
                                                            driverLicenseDateOfBirth.findIndex((element: any) => element.dateOfBirth === driverLicence.dateOfBirth) < 0 ? "la-eye" : "la-eye-slash"
                                                        }` : "data-value"}
                                                    ></em>
                                                </span>
                                                <span className="btn-text">Show / Hide DOB Text</span>
                                            </button>
                                        </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"drivers-license-" + index + "-license-number"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.licenseNumber")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"drivers-license-" + index + "-license-number"}>
                                              {driverLicence &&
                                                 driverLicence.driverLicenseNumber &&  driverLicenseCardNumber.findIndex((element: any) => element.driverLicenseNumber ===  driverLicence.driverLicenseNumber) < 0 ? 
                                                      `${"*".repeat(driverLicence.driverLicenseNumber.substr(0, driverLicence.driverLicenseNumber.length - 4).length)}${driverLicence.driverLicenseNumber.substr(
                                                        driverLicence.driverLicenseNumber.length - 4
                                                      )}`: driverLicence.driverLicenseNumber } 

<button
                                                type="button"
                                                className="btn-default btn-icon-only btn-no-padding"
                                                onClick={() => {
                                                    toggleDriverLicenseNumberVisibility(driverLicence);
                                                }}
                                                title={"Show DriverLicenseNumber Text"}
                                                style={{marginLeft: '1.25rem'}}
                                            >
                                                <span className="btn-icon">
                                                    <em
                                                        className={`las ${
                                                            driverLicenseCardNumber.findIndex((element: any) => element.driverLicenseNumber ===  driverLicence.driverLicenseNumber) < 0 ? "la-eye" : "la-eye-slash"
                                                        }`}
                                                    ></em>
                                                </span>
                                                <span className="btn-text">Show / Hide DriverLicenseNumber Text</span>
                                            </button>   
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"drivers-license-" + index + "-address"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.address")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"drivers-license-" + index + "-address"}>
                                                {driverLicence.address1}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"drivers-license-" + index + "-address-2"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.address2")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"drivers-license-" + index + "-address-2"}>
                                                {driverLicence.address2}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"drivers-license-" + index + "-drivers-license-1-state"}>
                                                License {i18nService.get("State.Label")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"drivers-license-" + index + "-drivers-license-1-state"}>
                                                {driverLicence.driverLicenseState}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"drivers-license-" + index + "-country"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.country")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"drivers-license-" + index + "-country"}>
                                                {driverLicence.country && countryList.find((s: any) => s.code === driverLicence.country)?.name}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"drivers-license-" + index + "-issue-date"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.issueDate")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"drivers-license-" + index + "-issue-date"}>
                                                {driverLicence.issueDate && getFormattedDate(i18nService.get("Country"), driverLicence.issueDate)}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"drivers-license-" + index + "-expiration-date"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.expiryDate")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"drivers-license-" + index + "-expiration-date"}>
                                                {driverLicence.expirationDate && getFormattedDate(i18nService.get("Country"), driverLicence.expirationDate)}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"drivers-license-" + index + "-conditions"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.condition")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"drivers-license-" + index + "-conditions"}>
                                                {driverLicence.conditions}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"drivers-license-" + index + "-class"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.class")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"drivers-license-" + index + "-class"}>
                                                {driverLicence.class}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"drivers-license-" + index + "-notes"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.notes")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"drivers-license-" + index + "-notes"}>
                                                {driverLicence.notes}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row between-xs margin-top-l">
                                    <div className="col-xs flex-grow-null col-no-gutter"></div>
                                    <div className="col-xs flex-grow-null col-no-gutter">
                                        <ul className="list-reset list-inline">
                                            <li>
                                                <button
                                                    type="button"
                                                    className="btn-default btn-red-outline btn-no-border"
                                                    onClick={() => showDeleteWalletDialog(driverLicence)}
                                                >
                                                    <span className="btn-icon">
                                                        <em className="las la-trash-alt"></em>
                                                    </span>
                                                    <span className="btn-text">
                                                        {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.deleteButtonText")}
                                                    </span>
                                                </button>
                                            </li>
                                            <li className="margin-left-xs">
                                                <button
                                                    type="button"
                                                    className="btn-default btn-primary-outline"
                                                    id={"edit-driver-licence-" + index}
                                                    onClick={() => showDriversLicenseDialog(driverLicence)}
                                                >
                                                    <span className="btn-icon">
                                                        <em className="las la-edit-alt"></em>
                                                    </span>
                                                    <span className="btn-text">
                                                        {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.editDetailsButtonText")}
                                                    </span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

            {/* Delete modal*/}
            {deleteWalletDialogIsVisible && (
                <DialogComponent dialogId="dialog-delete-drivers-license-wallet" title="Delete Wallet" closeDialog={closeDeleteWalletDialog}>
                    <ConfirmDeleteWalletDialog
                        requestDataCallback={props.requestDataCallback}
                        closeDialog={closeDeleteWalletDialog}
                        walletItem={selectedItem}
                        itemType="driver-licence"
                    />
                </DialogComponent>
            )}

            {/* Edit modal*/}
            {driversLicenseDialogIsVisible && (
                <DialogComponent dialogId="dialog-edit-drivers-license-wallet" title="Edit Drivers License Wallet" closeDialog={closeDriversLicenseDialog}>
                    <DriverLicenseDialog
                        requestDataCallback={props.requestDataCallback}
                        closeDialog={closeDriversLicenseDialog}
                        walletItem={selectedItem}
                        isNew={false}
                    />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default DriversLicense;
